"use client";
//#region packages/@mantine/core/src/core/MantineProvider/color-functions/get-primary-shade/get-primary-shade.ts
function getPrimaryShade(theme, colorScheme) {
	if (typeof theme.primaryShade === "number") return theme.primaryShade;
	if (colorScheme === "dark") return theme.primaryShade.dark;
	return theme.primaryShade.light;
}
//#endregion
export { getPrimaryShade };

//# sourceMappingURL=get-primary-shade.mjs.map